import { SwiperGamesListConfiguration } from "../../../../configurations/config-data-sections/arenas.configuration";
import {CasinoLegacyDeepLinkActionBase} from "../casino-legacy-deep-link-action-base";


abstract class OpenListDeeplinkAction extends CasinoLegacyDeepLinkActionBase {
  abstract getListConfig(id: string): SwiperGamesListConfiguration;

  async execute() {
    const id = this.descriptor.actionParams.id?.toString();
    let swiper: SwiperGamesListConfiguration = this.getListConfig(id);
    if (swiper) {
      const verticalGamesList = await this.services.verticalGamesList;
      await verticalGamesList.renderList(swiper);
    } else {
      this.services.logger.error(`For deeplink action ${this.descriptor.action} cannot find list with specified id: ${id}`);
    }
  }
}

export class OpenListDeeplinkByTitleAction extends OpenListDeeplinkAction {
  getListConfig(title: string): SwiperGamesListConfiguration {
    return this.services.configuration.getGamesListByTitle(title);
  }
}

export class OpenListDeeplinkByIdAction extends OpenListDeeplinkAction {
  getListConfig(id: string): SwiperGamesListConfiguration {
    return this.services.configuration.getGamesListById(Number(id));
  }
}
